{
  "name": "@databricks/sdk-jobs",
  "version": "0.21.0",
  "description": "",
  "type": "module",
  "exports": {
    "./v2": {
      "types": "./dist/v2/index.d.ts",
      "import": "./dist/v2/index.js",
      "default": "./dist/v2/index.js"
    }
  },
  "files": [
    "dist",
    "LICENSE"
  ],
  "scripts": {
    "build": "tsc -b",
    "lint": "eslint src --ext .ts",
    "lint:fix": "eslint src --ext .ts --fix",
    "format": "prettier --write \"src/**/*.ts\"",
    "format:check": "prettier --check \"src/**/*.ts\"",
    "typecheck": "tsc --noEmit",
    "clean": "rm -rf dist tsconfig.tsbuildinfo",
    "test": "echo 'no tests'",
    "test:browser": "echo 'no tests'"
  },
  "author": "Databricks",
  "license": "Apache-2.0",
  "repository": {
    "type": "git",
    "url": "https://github.com/databricks/sdk-js.git",
    "directory": "packages/jobs"
  },
  "dependencies": {
    "@databricks/sdk-auth": ">=0.21.0 <1.0.0",
    "@databricks/sdk-core": ">=0.21.0 <1.0.0",
    "@databricks/sdk-options": ">=0.21.0 <1.0.0",
    "@js-temporal/polyfill": "^0.5.0",
    "json-bigint": "^1.0.0",
    "zod": "^4.3.6"
  },
  "engines": {
    "node": ">=22.0.0"
  }
}
